import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { takePostLoginRedirect } from "@/lib/post-login-redirect";

/**
 * Entrega o deep link que o desvio pelo Entra não conseguiu carregar.
 *
 * Mora aqui, e não numa tela, porque o ponto de aterrissagem é
 * **configuração**: o callback redireciona para `ENTRA_POST_LOGIN_REDIRECT`, que
 * pode ser `/` (e aí o `GuestGuard` desvia para `/projects`) ou já `/projects`.
 * Pendurar o consumo em qualquer uma dessas telas amarraria o comportamento a um
 * valor de ambiente. Montado ao lado do `RouteAnalytics`, dentro do router e
 * fora dos guards, ele funciona em qualquer uma das duas.
 *
 * Não renderiza nada e não navega sozinho em situação normal: só quando existe
 * destino guardado, ele está fresco e a sessão já é válida. O `take` apaga na
 * leitura, então isto acontece no máximo uma vez por ida ao provedor — a
 * navegação seguinte da pessoa não é sequestrada.
 *
 * `replace`, não `push`: a raiz que o callback escolheu não é um passo do
 * histórico que alguém queira revisitar com o botão de voltar.
 */
export function PostLoginRedirect() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    const target = takePostLoginRedirect();
    if (target) navigate(target, { replace: true });
  }, [isAuthenticated, navigate]);

  return null;
}
